// Shared validation patterns used across form fields and dialogs.

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
